import { render, staticRenderFns } from "./SelectRejectReasonCorporate.vue?vue&type=template&id=42c8e126&"
import script from "./SelectRejectReasonCorporate.vue?vue&type=script&lang=js&"
export * from "./SelectRejectReasonCorporate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports